export interface ICheckboxInput {
  color?: string;
}
